import { useEffect, useState } from "react";

const navLinks = [
  { label: "首页", href: "#home" },
  { label: "核心服务", href: "#features" },
  { label: "客户端下载", href: "#download" },
  { label: "会员权益", href: "#membership" },
  { label: "充值服务", href: "#recharge" },
  { label: "客服帮助", href: "#help" },
  { label: "联系我们", href: "#contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-950/85 backdrop-blur-md border-b border-background-200/70"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <nav className="mx-auto max-w-7xl px-4 md:px-6" aria-label="主导航">
        <div className="flex h-16 md:h-[72px] items-center justify-between">
          <a href="#home" className="flex items-center gap-2.5 whitespace-nowrap">
            <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-950">
              <i className="ri-voiceprint-fill text-xl" aria-hidden="true"></i>
            </span>
            <span className="font-heading text-xl md:text-2xl tracking-wide text-foreground-50">
              歪歪<span className="text-primary-400">语音</span>
            </span>
          </a>

          <div className="hidden lg:flex items-center gap-7">
            {navLinks.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="text-sm font-medium text-foreground-200 hover:text-primary-400 transition-colors whitespace-nowrap"
              >
                {item.label}
              </a>
            ))}
          </div>

          <div className="hidden lg:flex items-center gap-3">
            <a
              href="#membership"
              className="rounded-md px-4 py-2 text-sm font-medium text-foreground-100 hover:text-primary-300 transition-colors whitespace-nowrap"
            >
              会员登录
            </a>
            <a
              href="#download"
              className="rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-950 hover:bg-primary-400 transition-colors whitespace-nowrap"
            >
              立即下载
            </a>
          </div>

          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden flex h-10 w-10 items-center justify-center rounded-md text-foreground-100 hover:bg-background-200/70"
            aria-label={open ? "关闭菜单" : "打开菜单"}
            aria-expanded={open}
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-3-line"} text-2xl`} aria-hidden="true"></i>
          </button>
        </div>

        {open && (
          <div className="lg:hidden pb-4 border-t border-background-200/70 pt-2">
            <div className="flex flex-col gap-1">
              {navLinks.map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={() => setOpen(false)}
                  className="rounded-md px-3 py-2.5 text-sm text-foreground-200 hover:bg-background-200/70 hover:text-primary-400 transition-colors"
                >
                  {item.label}
                </a>
              ))}
              <a
                href="#download"
                onClick={() => setOpen(false)}
                className="mt-2 rounded-md bg-primary-500 px-3 py-2.5 text-center text-sm font-semibold text-background-950 whitespace-nowrap"
              >
                立即下载
              </a>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}